/**
 * A simple in-memory store for session-scoped data
 * Used to store non-reactive global data limited to the current session
 * Mimics localStorage API with string values only
 */

// In-memory storage object with string values to match localStorage
const store: Record<string, string> = {};

/**
 * Set an item in the memory store
 */
export function setItem(key: string, value: unknown): void {
  store[key] = String(value);
}

/**
 * Get an item from the memory store
 * Returns null if key doesn't exist (matching localStorage behavior)
 */
export function getItem(key: string): string | null {
  return key in store ? store[key] : null;
}

/**
 * Remove an item from the memory store
 */
export function removeItem(key: string): void {
  delete store[key];
}

/**
 * Get all keys in the memory store
 */
export function getKeys(): string[] {
  return Object.keys(store);
}

/**
 * Clear all items from the memory store
 */
export function clear(): void {
  for (const key of Object.keys(store)) {
    delete store[key];
  }
}

/**
 * Check if a key exists in the memory store
 */
export function hasKey(key: string): boolean {
  return key in store;
}

const memStore = {
  setItem,
  getItem,
  removeItem,
  getKeys,
  clear,
  hasKey,
};

export default memStore;
